// __APIDOCS__ is a global variable from the webpack config
// eslint-disable-next-line no-undef
const apidocs = __APIDOCS__

// Sort the incoming categories
let mapped = apidocs.categories.map((el, i) => ({ index: i, value: el.name }))
mapped.sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0))
const sortedCategories = mapped.map(el => apidocs.categories[el.index])

// Set the initial state
const initialState = {
	categories: sortedCategories,
	selectedCategory: {},
	responses: apidocs.responses,
	enums: apidocs.enums,
}

export default function api(state = initialState, action) {
	switch (action.type) {
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/apiReducer.js